<div class="relative z-10 h-screen flex flex-col mx-auto sm:w-[600px]">
  <div class="h-[30vh] w-full"></div>

  <div class="h-[70vh] mx-4 max-w-2xl flex flex-col justify-center p-2 bg-white rounded-t-2xl" [ngClass]="{
    'animate-slide-up': !isClosing,
    'animate-slide-down': isClosing
  }" (animationend)="onAnimationEnd()">

    <!-- Ici on injecte le contenu spécifique au dialog -->
    <ng-content></ng-content>

  </div>
</div>
